var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParametricTestsOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7864_27935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 70L93 70",
    stroke: "#272d55",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 12,
    height: 49,
    rx: 6,
    fill: "#272d55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 34,
    width: 12,
    height: 22,
    rx: 6,
    fill: "#272d55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 16,
    width: 12,
    height: 40,
    rx: 6,
    fill: "#272d55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0772 98.7739H42.0166C39.3439 98.7739 38.0054 95.5425 39.8953 93.6526L47.4256 86.1223C48.5971 84.9507 50.4966 84.9507 51.6682 86.1223L59.1985 93.6526C61.0884 95.5425 59.7499 98.7739 57.0772 98.7739Z",
    fill: "#272d55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7864_27935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "#272d55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParametricTestsOperationIcon);
export default __webpack_public_path__ + "static/media/ParametricTestsOperationIcon.b01347c314620fba756161e07ed1a277.svg";
export { ForwardRef as ReactComponent };